import { C } from '../../theme.js';
import { Code, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

// ── Validate ───────────────────────────────────────────────────────────
export function RegexValidateInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Pattern</FieldLabel>
      <TextInput mono value={c.pattern} onChange={(v) => u({ pattern: v })}
        placeholder="^[\\w.+-]+@[\\w-]+\\.[\\w.-]+$" />
      <FieldLabel>Common patterns</FieldLabel>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {[
          { label: 'Email', pat: '^[\\w.+-]+@[\\w-]+\\.[\\w.-]+$' },
          { label: 'URL', pat: '^https?://[\\w./?=&-]+$' },
          { label: 'US ZIP', pat: '^\\d{5}(-\\d{4})?$' },
          { label: 'ISO date', pat: '^\\d{4}-\\d{2}-\\d{2}$' },
          { label: 'E.164 phone', pat: '^\\+[1-9]\\d{1,14}$' },
        ].map(p => (
          <button key={p.label} onClick={() => u({ pattern: p.pat })}
            style={{
              fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
              background: C.input, color: C.fg3,
              border: `1px solid ${C.border}`, borderRadius: 6,
              padding: '5px 9px', fontSize: '.74rem', display: 'flex', gap: 10,
            }}>
            <span style={{ color: C.fg2, flex: '0 0 100px', fontWeight: 600 }}>{p.label}</span>
            <Code style={{ background: 'transparent', padding: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.pat}</Code>
          </button>
        ))}
      </div>
      <FieldLabel>On failure</FieldLabel>
      <Segmented
        value={c.action || 'flag'}
        onChange={(v) => u({ action: v })}
        options={[
          { value: 'flag', label: 'Flag _valid' },
          { value: 'drop', label: 'Drop row' },
          { value: 'halt', label: 'Halt run' },
        ]}
      />
      {(c.action || 'flag') === 'flag' && (
        <>
          <FieldLabel hint={`Blank keeps the default name, ${c.column || 'col'}_valid`}>Output column</FieldLabel>
          <TextInput mono value={c.target || ''} onChange={(v) => u({ target: v })} placeholder={`${c.column || 'col'}_valid`} />
        </>
      )}
    </div>
  );
}
